import React, { Component } from 'react';
import './App.css';
import { Link } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(fab);

class Welcome extends Component {

  render(){
    var link = document.URL;

    return (
      <div className="Welcome">
        <div className="welcomeText">
          <p id="welcomeTitle">Data Science Interview Questions</p>
          <p id="desc">Chance Favors The Prepared Mind - Louis Pasteur</p>
        </div>
        <div className="btnGroup">
          <button id="contributeBtn"><Link to="/contribution" id="contributionLink">Contribute</Link></button>
          <button id="startBtn"><Link to="/questions" id="startLink">Start Now</Link></button>
        </div>
        <br/>
        <div>
          <p>Share on:&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="#"><FontAwesomeIcon icon={['fab', 'facebook-f']} color="darkgreen" /></a>&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="#"><FontAwesomeIcon icon={['fab', 'twitter']} color="darkgreen" /></a></p>&nbsp;&nbsp;
        </div>
      </div>
      );
  }
}  

export default Welcome;
